/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'warning': {
    width: 2,
    height: 12,
    viewBox: '0 0 2 12',
    data: '<defs><path pid="0" d="M9 4h2v8H9V4Zm1 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" id="svgicon_warning_a"/></defs><use _fill="#FFF" fill-rule="nonzero" xlink:href="#svgicon_warning_a" transform="translate(-9 -4)"/>'
  }
})
